import { ModalStates } from '@components'

import { CustomerModalState } from '../../../enums/CustomerModalState'
import { CompanyCustomerModalBody } from '../elements/CompanyCustomerModalBody'
import { AddContactPersonModalFooter } from '../elements/ContactPersons/elements/ContactPersonsTable/elements/AddContactPersonModalFooter'
import { ContactPersonsModalBody } from '../elements/ContactPersons/elements/ContactPersonsTable/elements/ContactPersonsModalBody'
import { EditContactPersonModalFooter } from '../elements/ContactPersons/elements/ContactPersonsTable/elements/EditContactPersonModalFooter'
import { CustomerModalFooter } from '../elements/CustomerModalFooter'
import { IndividualCustomerModalBody } from '../elements/IndividualCustomerModalBody'

export const getCustomerModalStates: (modalTitle?: string) => ModalStates<CustomerModalState> = (modalTitle) => [
  {
    id: CustomerModalState.AddContactPerson,
    ...(modalTitle ? { headerTitle: modalTitle } : { headerTKey: 'customer_modal.add_contact.header' }),
    modalBody: <ContactPersonsModalBody />,
    modalFooter: <AddContactPersonModalFooter />,
    closable: false,
    withBackwardsNavigation: true,
  },
  {
    id: CustomerModalState.Company,
    ...(modalTitle ? { headerTitle: modalTitle } : { headerTKey: 'customer_modal.company.header' }),
    modalBody: <CompanyCustomerModalBody />,
    modalFooter: <CustomerModalFooter />,
  },
  {
    id: CustomerModalState.EditContactPerson,
    ...(modalTitle ? { headerTitle: modalTitle } : { headerTKey: 'customer_modal.edit_contact.header' }),
    modalBody: <ContactPersonsModalBody />,
    modalFooter: <EditContactPersonModalFooter />,
    withBackwardsNavigation: true,
  },
  {
    id: CustomerModalState.Individual,
    ...(modalTitle ? { headerTitle: modalTitle } : { headerTKey: 'customer_modal.individual.header' }),
    modalBody: <IndividualCustomerModalBody />,
    modalFooter: <CustomerModalFooter />,
  },
]
